import {
  addTagTypes,
  baseClientApi as api,
  DownloadCaseApiV1CasesCaseIdUploadedGetApiArg,
  DownloadCaseApiV1CasesCaseIdUploadedGetApiResponse,
  GetOrganisationSubscriptionApiV1OrganisationsOrgIdGetApiArg,
  GetOrganisationSubscriptionApiV1OrganisationsOrgIdGetApiResponse,
  MarkCaseUploadedApiV1CasesCaseIdUploadedPutApiArg,
  MarkCaseUploadedApiV1CasesCaseIdUploadedPutApiResponse
} from "@/store/baseClientApi";
import { emptyApi } from "@/store/emptyApi";

const CreateTags = <T, V>(tag: V, result: T | T[] | undefined, selectId: (item: T) => string, isList?: boolean) =>
  result
    ? [
        ...(Array.isArray(result)
          ? result.map((item) => ({
              type: tag,
              id: selectId(item)
            }))
          : [
              {
                type: tag,
                id: selectId(result)
              }
            ]),
        ...(isList ? [{ type: tag, id: "LIST" }] : [])
      ]
    : [tag];

const clientApi = api.enhanceEndpoints({
  addTagTypes: ["users-meta"],
  endpoints: {
    getCasesApiV1CasesGet: { providesTags: (result) => CreateTags("cases", result?.content, (item) => item.id.toString(), true) },
    getOrganisationApiV1OrganisationsOrgIdGet: {
      providesTags: (result) => CreateTags("organisations", result, (item) => item.id.toString())
    },
    getOrganisationSubscriptionApiV1OrganisationsOrgIdGet: {
      providesTags: (_result, _error, arg) => CreateTags("organisations", arg.orgId, (item) => item.toString())
    }
  }
});

const downloadMutationApi = emptyApi
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: (build) => ({
      downloadUploadedCaseData: build.mutation<
        DownloadCaseApiV1CasesCaseIdUploadedGetApiResponse,
        DownloadCaseApiV1CasesCaseIdUploadedGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases/${queryArg.caseId}/download`
        })
      }),
      markCaseApiV1CasesCaseIdUploadedPut: build.mutation<
        MarkCaseUploadedApiV1CasesCaseIdUploadedPutApiResponse,
        MarkCaseUploadedApiV1CasesCaseIdUploadedPutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/cases/${queryArg.caseId}/mark-uploaded`
        })
      }),
      getOrganisationBillingSessionApiV1OrganisationsOrgIdGet: build.mutation<
        GetOrganisationSubscriptionApiV1OrganisationsOrgIdGetApiResponse,
        GetOrganisationSubscriptionApiV1OrganisationsOrgIdGetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/organisations/${queryArg.orgId}/billing/session`
        })
      })
    }),
    overrideExisting: true
  });

export const REFETCH_TIMEOUT = 4000;

export * from "@/store/baseClientApi";
export { clientApi };

export const {
  useDownloadUploadedCaseDataMutation,
  useGetOrganisationBillingSessionApiV1OrganisationsOrgIdGetMutation,
  useMarkCaseApiV1CasesCaseIdUploadedPutMutation
} = downloadMutationApi;
